<template>
  <div class="frame">
    <div class="container">
      <div class="row no-gutters">
        <div class="col">
          <h1>{{ $t("calculationinput.intro") }}</h1>
          <p class="font-weight-normal">
            {{ $t("calculationinput.rcValueLabel") }}
          </p>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <div class="c input-wrapper inline-block">
            <span class="block mb-10">{{
              $t("calculationinput.rc-value")
            }}</span>
            <select
              v-model="rcValue"
              name="rc-value"
              id="rc-value"
              class="block w-100"
            >
              <option
                v-for="value in rcValuesOptions"
                :key="value"
                :value="value"
              >
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <img
            v-if="!isFrenchCulture"
            class="c img-fluid w-100"
            src="../assets/images/berekening-voorbeeld.jpg"
            :alt="$t('calculationinput.exampleImageAlt')"
          />

          <img
            v-else
            class="c img-fluid w-100"
            src="../assets/images/berekening-voorbeeld-fr-be.png"
            :alt="$t('calculationinput.exampleImageAlt')"
          />
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <p class="font-weight-normal mb-0">
            {{ $t("calculationinput.fillInMeasurements") }}
          </p>
          <p>
            {{ $t("calculationinput.fillInmeasurementsExplanation") }}
          </p>

          <validation-observer
            ref="inputForm"
            v-slot="{ errors, invalid, validated }"
          >
            <div class="c input-steps">
              <div class="input-step input-wrapper grey inline-block">
                <span class="block mb-10">{{
                  $t("calculationinput.lengthInMills")
                }}</span>
                <validation-provider
                  rules="required|min_value:4000|max_value:8000"
                  name="length"
                  v-slot="{ errors }"
                >
                  <input
                    class="w-100"
                    :class="{ 'with-error': errors[0] }"
                    type="number"
                    name="length"
                    id="length"
                    v-model="length"
                  />
                </validation-provider>
              </div>
              <div class="input-step input-wrapper inline-block">
                <span class="block mb-10">{{
                  $t("calculationinput.widthInMIlls")
                }}</span>
                <input
                  class="w-100"
                  type="number"
                  name="width"
                  id="width"
                  v-model="width"
                  lazy
                />
              </div>
              <div class="input-step input-wrapper inline-block">
                <span class="block mb-10">{{
                  $t("calculationinput.amountRoofSurface")
                }}</span>
                <select
                  v-model="roofSurfaces"
                  name="roofSurfaces"
                  id="roofSurfaces"
                  class="block w-100"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>
              <div class="input-step green input-wrapper inline-block">
                <div class="mb-10 text-white flex items-center">
                  <span class="inline-block">{{
                    $t("calculationinput.totalSurface")
                  }}</span>
                  <i
                    class="ml-10"
                    :data-tooltip="$t('calculationinput.concernsBothSurfaces')"
                  >
                    <svg
                      aria-hidden="true"
                      data-prefix="fal"
                      data-icon="info-circle"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      preserveAspectRatio
                      class="w-16"
                    >
                      <path
                        fill="currentColor"
                        d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                      /></svg
                  ></i>
                </div>
                <input
                  type="text"
                  name="width"
                  id="width"
                  class="no-appearance text-white font-weight-bold w-100"
                  disabled
                  :value="totalSurfaceArea"
                />
              </div>
            </div>
            <div v-if="invalid && validated" class="row no-gutters">
              <div class="col col-lg-6">
                <div class="c">
                  <p class="text-danger text-sm" v-if="errors['length'][0]">
                    {{ $t("calculationinput.errorMessage") }}
                  </p>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <p class="font-weight-normal mb-0">
            {{ $t("calculationinput.fillInAmountOfSupportPoints") }}
          </p>
          <p>
            {{ $t("calculationinput.fillInAmountOfRoofElements") }}
          </p>
          <div class="input-wrapper inline-block">
            <span class="block mb-10">{{
              $t("calculationinput.supportPoints")
            }}</span>
            <select
              v-model="supportPoints"
              name="rc-value"
              id="rc-value"
              class="block w-100"
            >
              <option
                v-for="value in supportPointsOptions"
                :key="value"
                :value="value"
              >
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalculationInput",
  computed: {
    ...mapGetters(["totalSquaredMetersAsString", "isFrenchCulture"]),
    totalSurfaceArea() {
      return `${this.totalSquaredMetersAsString} m²`;
    },
    rcValue: {
      get() {
        return this.$store.state.selectedProperties.rcValue;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY", {
          property: "rcValue",
          data: value
        });
      }
    },
    length: {
      get() {
        return this.$store.state.selectedProperties.length;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY", {
          property: "length",
          data: value
        });
      }
    },
    width: {
      get() {
        return this.$store.state.selectedProperties.width;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY", {
          property: "width",
          data: value
        });
      }
    },
    supportPoints: {
      get() {
        return this.$store.state.selectedProperties.supportPoints;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY", {
          property: "supportPoints",
          data: value
        });
      }
    },
    roofSurfaces: {
      get() {
        return this.$store.state.selectedProperties.roofSurfaces;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY", {
          property: "roofSurfaces",
          data: Number(value)
        });
      }
    },
    supportPointsOptions() {
      return this.$store.state.supportPointOptions;
    },
    rcValuesOptions() {
      return this.$store.getters["rcValuesOptions"];
    }
  }
};
</script>

<style lang="scss" scoped>
.input-steps {
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 992px) {
    flex-wrap: nowrap;
  }
}

.input-step {
  position: relative;

  @media (max-width: 992px) {
    padding: 1.5rem;
    width: 100%;
    border-bottom: 1px solid #fff;
  }

  @media (min-width: 992px) {
    padding-left: 3.125rem;

    &:not(:first-child) {
      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 50%;
        margin-top: -55px;
        border-top: 55px inset transparent;
        border-bottom: 55px inset transparent;
        border-left: 30px solid #f7f7f7;
        left: -2px;
        z-index: 2;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 50%;
        margin-top: -55px;
        border-top: 55px solid transparent;
        border-bottom: 55px solid transparent;
        border-left: 30px solid #fff;
        left: 0;
      }
    }
  }
}
</style>
